import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card } from "../../components"


export const View = () =>{
    return(
        <>
            <SettingsNavLinks
            navtitle="Settings"
            navtitlelink="Linked external Account"
            />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business
             profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
            />
            <Card>
            <strong>NO DESIGN FOR THIS PAGE </strong>
            </Card>
        </>
    )
}
